var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"d-print-none"},[_c('div',{staticClass:"desktop-logo-wrapper"},[_c(_setup.BaseLogo,{staticClass:"d-none d-lg-inline-block"})],1),_c(_setup.Navbar,{attrs:{"show-chevrons":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }